export default function useHasSlot(slots) {
  const slotList = slots;

  function hasSlot(name) {
    return !!slotList[name];
  }

  return {
    hasSlot
  };
}